import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_ePulse/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'

import {PharmaDashboardWrapper} from '../MasterModules/DoctorModule/pages/dashboard/PharmaDashboardWrapper'
import {getCSSVariableValue} from '../../_ePulse/assets/ts/_utils'
import {WithChildren} from '../../_ePulse/helpers'
import ProfilePages from '../MasterModules/PharmaModule/modules/patient/patientPage'
import {AddStockPage} from '../MasterModules/PharmaModule/modules/vendor/addStockPage'

const PhamraRoutes = () => {
  const SwitchBusinessPage = lazy(
    () => import('../common/modules/switchBusiness/SwitchBusinessPage')
  )

  const InventoryPage = lazy(
    () => import('../MasterModules/PharmaModule/modules/inventory/inventoryPage')
  )
  const VendorPage = lazy(() => import('../MasterModules/PharmaModule/modules/vendor/vendorPage'))
  const PatientPage = lazy(
    () => import('../MasterModules/PharmaModule/modules/patient/patientPage')
  )
  //const PrescriptionCodePage = lazy(() => import('../MasterModules/DoctorModule/modules/prescriptionCode/prescriptionCodePage'))

  const PrescriptionCodePage = lazy(
    () => import('../MasterModules/PharmaModule/modules/prescriptionCode/prescriptionCodePage')
  )
  const StaffIPRestrictionPage = lazy(
    () => import('../common/modules/staffIPRestriction/IPResctrictionPage')
  )
  const SaleOrderPage = lazy(
    () => import('../MasterModules/PharmaModule/modules/saleOrder/SaleOrderBreadcrumbPage')
  )
  const DoctorSaleOrderPage = lazy(
    () => import('../MasterModules/PharmaModule/modules/saleOrder/doctorOrderPage')
  )

  const OrderHistoryPage = lazy(
    () =>
      import('../MasterModules/PharmaModule/modules/orderHistory/saleOrderHistory/OrderHistoryPage')
  )

  const ReturnSalesOrderHistoryPage = lazy(
    () =>
      import(
        '../MasterModules/PharmaModule/modules/orderHistory/returnSalesOrderHistory/ReturnSalesOrderHistoryPage'
      )
  )

  const ReturnPurchaseOrderHistoryPage = lazy(
    () =>
      import(
        '../MasterModules/PharmaModule/modules/orderHistory/returnPurchaseOrderHistory/ReturnPurchaseOrderHistoryPage'
      )
  )

  // ./MasterModules/PharmaModule/modules/transaction/payment/OrderHistoryPage

  const PurchaseOrderHistoryPage = lazy(
    () =>
      import(
        '../MasterModules/PharmaModule/modules/orderHistory/purchaseOrderHistory/PurchaseOrderHistoryPage'
      )
  )

  const ApplicationSettingsPage = lazy(() => import('../common/modules/appSetting/AppSettingsPage'))
  const RolesPermissionPage = lazy(
    () => import('../MasterModules/DoctorModule/modules/RolePermission/RolePermissionPage')
  )

  const NotificationPage = lazy(() => import('../common/modules/notification/NotificationPage'))
  const StaffPage = lazy(() => import('../MasterModules/PharmaModule/modules/staff/staffPage'))
  const BillingTemplatePage = lazy(
    () => import('../MasterModules/PharmaModule/modules/billingTemplate/BillingTemplatePage')
  )
  const DiscountSettingsPage = lazy(
    () => import('../MasterModules/PharmaModule/modules/discountSettings/discountSettingsPage')
  )
  

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='dashboard' element={<PharmaDashboardWrapper />} />
        <Route path='patient' element={<ProfilePages />} />

        <Route
          path='/switch_business/*'
          element={
            <SuspensedView>
              <SwitchBusinessPage />
            </SuspensedView>
          }
        />

        <Route
          path={'business-app-setting/*'}
          element={
            <SuspensedView>
              <ApplicationSettingsPage />
            </SuspensedView>
          }
        />
        <Route
          path='roles-permission/*'
          element={
            <SuspensedView>
              <RolesPermissionPage />
            </SuspensedView>
          }
        />
        <Route
          path='billing-template/*'
          element={
            <SuspensedView>
              <BillingTemplatePage />
            </SuspensedView>
          }
        />
        <Route
          path={'/settingssection/discount-settings/*'}
          element={
            <SuspensedView>
              <DiscountSettingsPage />
            </SuspensedView>
          }
        />


        <Route
          path='notification/*'
          element={
            <SuspensedView>
              <NotificationPage />
            </SuspensedView>
          }
        />

        <Route
          path='staff-management/*'
          element={
            <SuspensedView>
              <StaffPage />
            </SuspensedView>
          }
        />

        <Route
          path={'/inventory/active'}
          element={
            <SuspensedView>
              <InventoryPage />
            </SuspensedView>
          }
        />
        <Route
          path={'/inventory/in-active'}
          element={
            <SuspensedView>
              <InventoryPage />
            </SuspensedView>
          }
        />
        <Route
          path={'/vendor/*'}
          element={
            <SuspensedView>
              <VendorPage />
            </SuspensedView>
          }
        />

        <Route
          path={'/patients/*'}
          element={
            <SuspensedView>
              <PatientPage />
            </SuspensedView>
          }
        />
        <Route
          path={'/prescription-codes/*'}
          element={
            <SuspensedView>
              <PrescriptionCodePage />
            </SuspensedView>
          }
        />
        <Route
          path='/orders/sales-order-history/*'
          element={
            <SuspensedView>
              <OrderHistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='/orders/purchase-order-history/*'
          element={
            <SuspensedView>
              <PurchaseOrderHistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='/add-stock/*'
          element={
            <SuspensedView>
              <AddStockPage />
            </SuspensedView>
          }
        />
        <Route
          path='/orders/return-sales-order-history/*'
          element={
            <SuspensedView>
              <ReturnSalesOrderHistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='/orders/purchase-order-history/*'
          element={
            <SuspensedView>
              <PurchaseOrderHistoryPage />
            </SuspensedView>
          }
        />
        <Route
          path='/orders/return-purchase-order-history/*'
          element={
            <SuspensedView>
              <ReturnPurchaseOrderHistoryPage />
            </SuspensedView>
          }
        />

        <Route
          path={'/sale-order/*'}
          element={
            <SuspensedView>
              <SaleOrderPage />
            </SuspensedView>
          }
        />
        <Route
          path={'/doctor-sale-order/*'}
          element={
            <SuspensedView>
              <DoctorSaleOrderPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PhamraRoutes}
